import React from 'react';

import { useParams } from 'react-router';

import { FormProvider } from 'context/FormContext';
import { ListagemProvider } from 'context/ListagemContext';
import { usePermissionsContext } from 'context/PermissionsContext';
import { NotaDevolucaoFormComp, NotaDevolucaoListComp } from 'pages/financeiro/nota-devolucao/components';

export function NotaDevolucaoList() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();

    if (!hasPermission(['FINANCEIRO_DEVOLUCAO_VISUALIZAR'])) return alertNotPermission();

    return (
        <ListagemProvider>
            <NotaDevolucaoListComp />
        </ListagemProvider>
    );
}

export function NotaDevolucaoForm() {
    const { hasPermission, alertNotPermission } = usePermissionsContext();
    if (!hasPermission(['FINANCEIRO_DEVOLUCAO_SIMULAR'])) return alertNotPermission();

    return (
        <FormProvider>
            <ListagemProvider>
                <NotaDevolucaoFormComp />
            </ListagemProvider>
        </FormProvider>
    );
}
